 $(document).ready(function() {
  //  var $el = $('.banners-slider');
  // $el.slick({
  //   dots: true,
  //   arrows: true,
  //   speed: 300,
  //   slidesToShow: 1,
  //   adaptiveHeight: true,
  //   onInit: function(e){
  //   $el.append('<div class="slick-counter">'+ parseInt(e.currentSlide + 1, 10) +' / '+ e.slideCount +'</div>');
  //   },
  //   onAfterChange: function(e){
  //     $el.find('.slick-counter').html(e.currentSlide + 1 +' / '+e.slideCount);
  //   }
  // });

   $(document).on('click','.scroll_down a',function(e){
     e.preventDefault();
     var link = $(this).attr('href');
     $( 'html, body' ).animate({
		scrollTop: $( link ).offset().top
     }, 'slow' );
     
   });

  var $slider = $('.banners-slider');
  if ($slider.length) {
    var currentSlide;
    var slidesCount;
    var sliderCounter = document.createElement('div');
    sliderCounter.classList.add('slider__counter');
    
    var updateSliderCounter = function(slick, currentIndex) {
      currentSlide = slick.slickCurrentSlide() + 1;
      slidesCount = slick.slideCount;
      $(sliderCounter).html(currentSlide + '<span class="seprater"></span>' +slidesCount)
    };
  
    $slider.on('init', function(event, slick) {
      $slider.after(sliderCounter);
      updateSliderCounter(slick);
    });
  
    $slider.on('afterChange', function(event, slick, currentSlide) {
      updateSliderCounter(slick, currentSlide);
    });
  
    $slider.slick();
  }

  $('.size_list').slick({
    dots: true,
    arrows: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.collection_list_slider').slick({
    dots: true,
    arrows: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }); 

   $('.product_slider').slick({
            dots: true,
            arrows: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 550,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });
});  



// accordion

$("#accordion > li > h3").click(function(){

	if(false == $(this).next().is(':visible')) {
		$('#accordion ul').slideUp(300);
	}

	var classnm = $(this).parent('li').attr("class");
	// Line Added to remove the active class from all 'li'
	$('#accordion > li').removeClass('active');
	// Line Added to remove the blank attribute of class from all 'li'
	$('#accordion > li[class=""]').removeAttr('class');
	// Line Added to add the active class in current 'li'

	$(this).next().slideToggle(300);

	if(classnm == "undefined" || classnm == "" || classnm == undefined){
		$(this).parent('li').addClass('active');
	}
});

$('#accordion ul:eq(0)').show();


(function($) {
    $.fn.Popup = function(options) {
        var defaults = $.extend({
            centerPopup: true,
            open: function() {},
            closed: function() {}
        }, options);

        /******************************
        Private Variables
        *******************************/

        var object = $(this);
        var settings = $.extend(defaults, options);

        /******************************
        Public Methods
        *******************************/

        var methods = {
            init: function() {
                return this.each(function() {
                    methods.appendHTML();
                    methods.setEventHandlers();
                    methods.showPopup();
                });
            },

            /******************************
            Append HTML
            *******************************/

            appendHTML: function() {

                // if this has already been added we don't need to add it again
                if ($('.PopupBackground').length === 0) {
                    var background = '<div class="PopupBackground"></div>';
                    $('body').prepend(background);
                }

                if (object.find('.PopupClose').length === 0) {
                    var close = '<div class="PopupClose">X</div>';
                    object.prepend(close);
                }
            },

            /******************************
            Set Event Handlers
            *******************************/

            setEventHandlers: function() {
                $(".PopupClose, .PopupBackground").on("click", function(event) {
                    methods.hidePopup();
                });
                $(window).on("resize", function(event) {
                    if (settings.centerPopup) {
                        methods.positionPopup();
                    }
                });

            },

            removeEventListners: function() {
                $(".PopupClose, .PopupBackground").off("click");
            },

            showPopup: function() {
                $(".PopupBackground").css({
                    "opacity": "0.7"
                });
                $(".PopupBackground").fadeIn("fast");
                object.fadeIn("slow", function() {
                    settings.open();
                });
                if (settings.centerPopup) {
                    methods.positionPopup();
                }
            },
            hidePopup: function() {
                $(".PopupBackground").fadeOut("fast");
                object.fadeOut("fast", function() {
                    methods.removeEventListners();
                    settings.closed();
                });
            },

            positionPopup: function() {
                var windowWidth = $(window).width();
                var windowHeight = $(window).height();
                var popupWidth = object.width();
                var popupHeight = object.height();

                var topPos = (windowHeight / 2) - (popupHeight / 2);
                var leftPos = (windowWidth / 2) - (popupWidth / 2);
                if (windowWidth < 1025) {
                    var leftPos = (windowWidth / 2) - (popupWidth / 1.9);
                }
                if (windowWidth < 767) {
                    var leftPos = (windowWidth / 2) - (popupWidth / 1.7);
                }
                if (topPos < 30) topPos = 30;

                object.css({
                    "position": "absolute",
                    "top": topPos,
                    "left": leftPos
                });
            },

        };

        if (methods[options]) { // $("#element").pluginName('methodName', 'arg1', 'arg2');
            return methods[options].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof options === 'object' || !options) { // $("#element").pluginName({ option: 1, option:2 });
            return methods.init.apply(this);
        } else {
            $.error('Method "' + method + '" does not exist in popup plugin!');
        }
    };

})(jQuery);


/*!
 * Careers page
 * 
 */

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('#smoothie-job-content span.detail[title="Compensation"] span').forEach(el => {
        el.textContent = el.textContent.replace(/gbp /g, '');
    });
});